  <template>
    <div class="Reports__View">
      <EntityListLayout v-if="tabs.length" :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
        <template #title>קבצים</template>
        <template #button>
          <a @click="addFile" class="link-button">
            הוספת קובץ
          </a>
        </template>
        <template v-slot:counter="slotProps">
          סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
        </template>
      </EntityListLayout>
    </div>
  </template>
  <script>
  import AdminService from "@/services/AdminService";
  import EntityListLayout from "@/components/EntityListLayout.vue";
  import DialogAddFile from '@/components/DialogAddFile.vue';
  import {
    ModalProgrammatic as Modal,
  } from 'buefy';
  import FieldService from "@/services/FieldService";
  export default {
    name: "AdminFiles",
    data() {
      return {
        tabs: [],
      };
    },
    components: {
      EntityListLayout,
    },
    created() {
      this.create();
    },
    methods: {
      create() {
        const lessonsFields = FieldService.list("files");

        // const sideViewEntity = {
        //   component: CouponEntity,
        //   preview: true,
        //   readOnly: !this.isAdmin,
        //   title: "פרטי קובץ",
        //   recordUrl: "books",
        //   recordTitle: "הצג קובץ",
        //   hideRecord: true
        // };
        const fields = [
          { ...lessonsFields.FileName, checked: true },
          { ...lessonsFields.FileCreatedAt, checked: true },
          { ...lessonsFields.FileUrl, checked: true },
          { ...lessonsFields.CopyFileUrl, checked: true },
          { ...lessonsFields.DeleteFile, checked: true },
        ];

        this.tabs = [
          {
            id: "AdminSiteImages",
            isPrimary: true,
            title: "כללי",
            getDataAsync: ({ cancelToken, setPermanentQuery, ...rest }) => {
              const query = rest;
              query.type = 1;
              return this.getFiles({ cancelToken, ...query });
            },
            type: 1,
            perPage: 100,
            fields,
            filters: null,
            sortField: "lastModified",
            sortOrder: "asc",
            checkableRows: false,
            fastSearch: true,
            fastSearchOptions: {
              propName: "Terms",
              label: "חיפוש מהיר",
            },
          },
          {
            id: "AdminBookImages",
            isPrimary: true,
            title: "ספרים",
            getDataAsync: ({ cancelToken, setPermanentQuery, ...rest }) => {
              const query = rest;
              query.type = 2;
              return this.getFiles({ cancelToken, ...query });
            },
            type: 1,
            perPage: 100,
            fields,
            filters: null,
            sortField: "lastModified",
            sortOrder: "asc",
            checkableRows: false,
            fastSearch: true,
            fastSearchOptions: {
              propName: "Terms",
              label: "חיפוש מהיר",
            },
          },
          {
            id: "AdminMessagesImages",
            isPrimary: true,
            title: "הודעות",
            getDataAsync: ({ cancelToken, setPermanentQuery, ...rest }) => {
              const query = rest;
              query.type = 3;
              return this.getFiles({ cancelToken, ...query });
            },
            type: 1,
            perPage: 100,
            fields,
            filters: null,
            sortField: "lastModified",
            sortOrder: "asc",
            checkableRows: false,
            fastSearch: true,
            fastSearchOptions: {
              propName: "Terms",
              label: "חיפוש מהיר",
            },
          },
          {
            id: "AdminLectures",
            isPrimary: true,
            title: "הרצאות",
            getDataAsync: ({ cancelToken, setPermanentQuery, ...rest }) => {
              const query = rest;
              query.type = 5;
              return this.getFiles({ cancelToken, ...query });
            },
            type: 1,
            perPage: 100,
            fields,
            filters: null,
            sortField: "lastModified",
            sortOrder: "asc",
            checkableRows: false,
            fastSearch: true,
            fastSearchOptions: {
              propName: "Terms",
              label: "חיפוש מהיר",
            },
          },
          {
            id: "AdminEmails",
            isPrimary: true,
            title: "דואר אלקטרוני",
            getDataAsync: ({ cancelToken, setPermanentQuery, ...rest }) => {
              const query = rest;
              query.type = 6;
              return this.getFiles({ cancelToken, ...query });
            },
            type: 1,
            perPage: 100,
            fields,
            filters: null,
            sortField: "lastModified",
            sortOrder: "asc",
            checkableRows: false,
            fastSearch: true,
            fastSearchOptions: {
              propName: "Terms",
              label: "חיפוש מהיר",
            },
          },
          {
            id: "AdminHomePage",
            isPrimary: true,
            title: "דף הבית",
            getDataAsync: ({ cancelToken, setPermanentQuery, ...rest }) => {
              const query = rest;
              query.type = 7;
              return this.getFiles({ cancelToken, ...query });
            },
            type: 1,
            perPage: 100,
            fields,
            filters: null,
            sortField: "lastModified",
            sortOrder: "asc",
            checkableRows: false,
            fastSearch: true,
            fastSearchOptions: {
              propName: "Terms",
              label: "חיפוש מהיר",
            },
          },
          {
            id: "AdminLawsCollection",
            isPrimary: true,
            title: "חקיקה",
            getDataAsync: ({ cancelToken, setPermanentQuery, ...rest }) => {
              const query = rest;
              query.type = 8;
              return this.getFiles({ cancelToken, ...query });
            },
            type: 1,
            perPage: 100,
            fields,
            filters: null,
            sortField: "lastModified",
            sortOrder: "asc",
            checkableRows: false,
            fastSearch: true,
            fastSearchOptions: {
              propName: "Terms",
              label: "חיפוש מהיר",
            },
          },
          {
            id: "AdminFlipCardFiles",
            isPrimary: true,
            title: "כרטיסיות",
            getDataAsync: ({ cancelToken, setPermanentQuery, ...rest }) => {
              const query = rest;
              query.type = 9;
              return this.getFiles({ cancelToken, ...query });
            },
            type: 1,
            perPage: 100,
            fields,
            filters: null,
            sortField: "lastModified",
            sortOrder: "asc",
            checkableRows: false,
            fastSearch: true,
            fastSearchOptions: {
              propName: "Terms",
              label: "חיפוש מהיר",
            },
          },
        ];
        if (!this.$route.query.tab) {
          this.$router.replace({ path: this.$route.path, query: { tab: this.tabs[0].id } });
        }
      },
      addFile() {
        Modal.open({
          component: DialogAddFile,
          events: {
            customEvent: () => {
              const tabId = this.$route.query.tab || 'AdminSiteImages';
              const tabIdx = this.tabs.findIndex(tab => tab.id === tabId);
              this.$refs.entity.getData(this.tabs[tabIdx >= 0 ? tabIdx : 0]);
            }
          },
          canCancel: false,
          hasModalCard: true,
          trapFocus: true,
        });
      },
      onNewEntitySave() {
        this.$refs.entity.onNewEntityCancel();
      },
      getFiles({ ...rest }) {
        return AdminService.getFilesInStorage(rest.type, rest)
        .then((r) => {
          const sortField = rest.SortedBy || 'lastModified';
          
          // Sort the data based on the selected field and order
          const sortedData = r.data.sort((a, b) => {
            let valueA = a[sortField];
            let valueB = b[sortField];
            
            // Handle date sorting
            if (sortField === 'lastModified') {
              valueA = new Date(valueA);
              valueB = new Date(valueB);
            }
            
            // Handle string sorting (case insensitive)
            if (typeof valueA === 'string' && typeof valueB === 'string') {
              valueA = valueA.toLowerCase();
              valueB = valueB.toLowerCase();
            }
            
            // Compare and return based on sort order
            if (valueA < valueB) {
              return rest.IsAscending ? -1 : 1;
            }
            if (valueA > valueB) {
              return rest.IsAscending ? 1 : -1;
            }
            return 0;
          });
          
          return {
            data: {
              TotalResults: sortedData.length,
              Items: sortedData,
            },
          };
        });
      },
      getTotalRecords(slotProps) {
        return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
      },
    },
  };
  </script>
  <style scoped lang="scss">
  .Reports__View{
    height: 100%;
  }
  .link-button {
    background: #00427e;
    border: none;
    border-radius: 3px;
    padding: 14px 25px;
    color: white;
    cursor: pointer;
  }
  // .not-activated-row {
  //   background-color: #fff !important;
  // }
  </style>
